import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Modal } from '../../../components/Modal';
import type { Mensagem } from '../lib/tipos';

interface Props {
  aberto: boolean;
  mensagem: Mensagem | null;
  onFechar: () => void;
  onSalvar: (texto: string) => void | Promise<void>;
}

export function ModalEditarMensagem({ aberto, mensagem, onFechar, onSalvar }: Props) {
  const [texto, setTexto] = useState('');
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (mensagem) setTexto(mensagem.texto ?? ''); }, [mensagem?.id]);
  useEffect(() => { if (!aberto) setSalvando(false); }, [aberto]);

  async function aoSalvar() {
    if (!texto.trim() || salvando) return;
    setSalvando(true);
    try {
      await onSalvar(texto);
    } finally {
      setSalvando(false);
    }
  }

  if (!aberto || !mensagem) return null;
  const inalterado = (mensagem.texto ?? '') === texto;
  return (
    <Modal
      aberto={aberto}
      onFechar={salvando ? () => {} : onFechar}
      titulo="Editar mensagem"
      largura={500}
      rodape={
        <>
          <button type="button" className="btn-secundario" onClick={onFechar} disabled={salvando}>Cancelar</button>
          <button type="button" className="btn-primario flex items-center gap-1.5"
            onClick={aoSalvar} disabled={!texto.trim() || inalterado || salvando}>
            {salvando && <Loader2 size={14} className="animate-spin" />}
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </>
      }
    >
      <textarea
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        rows={4}
        autoFocus
        disabled={salvando}
        className="w-full px-3 py-2 border rounded-lg outline-none focus:ring-2 focus:ring-blue-400 disabled:opacity-60"
        style={{ fontSize: '16px' }}
      />
      <p className="text-xs text-gray-500 mt-2">Edicao via Baileys (Compras). WhatsApp limita edicao a ~15 minutos apos o envio.</p>
    </Modal>
  );
}
